<div class="organization-logo-container">
  <span class="organization-logo-container__header">
    {{ "LABELS.COMMERCIAL_LOGO" | translate | uppercase }}

    <span class="d-lg-none">
      <app-hint-tooltip-icon [hint]="'LABELS.COMMERCIAL_LOGO_DESCRIPTION' | translate"></app-hint-tooltip-icon>
    </span>
  </span>
  <div class="d-flex">
    <div class="col-12 col-lg-8 pl-0 pr-0">
      <document-upload-image
        [downloadLink]="logoUri"
        [isLoading]="isLoading"
        [isShowLoader]="!!organizationId"
        (upload)="uploadLogo($event)"
        (remove)="removeLogo()"
      ></document-upload-image>
    </div>

    <div class="d-none d-lg-block col-4">
      <div class="organization-logo-container__description">
        <span>{{ "LABELS.COMMERCIAL_LOGO_DESCRIPTION" | translate }}</span>
      </div>
    </div>
  </div>
</div>
